import { render, staticRenderFns } from "./CategoryViewSelect.vue?vue&type=template&id=bcfc5208&scoped=true&"
import script from "./CategoryViewSelect.vue?vue&type=script&lang=ts&"
export * from "./CategoryViewSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfc5208",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
